export interface AnessaListItem {
  uuid: string | null;
  getUuidForPath?(): string;
}

export default class AnessaListItemUtil {

  /**
   * Returns a formatted string that is used for the path in the sensitivity and scenario comparison input objects.
   * This function serves as a single point that can be changed to affect all input paths.
   * @param uuid
   */
  static getUuidForPath(uuid: string) {
    return uuid;
  }
}
